import getStore from '../store';
import { mutator } from 'satcheljs';
import { setItemUnavailable } from 'owa-calendar-actions';

/**
 * Set the item unavailable flag for the search item, since user either deleted or declined the meeting invite.
 */
export let setItemUnavailableMutator = mutator(setItemUnavailable, () => {
    let store = getStore();
    store.searchResults[store.selectedItemId].isDeleted = true;
});
